"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundWebhookAuthSchema = exports.WebhookNoneAuthSchema = exports.WebhookDirecionalPermutasAuthSchema = exports.WebhookOauthAuthSchema = exports.WebhookBasicAuthSchema = exports.OutboundWebhookAuthTypes = void 0;
const zod_1 = require("zod");
var OutboundWebhookAuthTypes;
(function (OutboundWebhookAuthTypes) {
    OutboundWebhookAuthTypes["OAUTH"] = "oauth";
    OutboundWebhookAuthTypes["USER_PASSWORD"] = "user_password";
    OutboundWebhookAuthTypes["BASIC"] = "basic";
    OutboundWebhookAuthTypes["NONE"] = "none";
    OutboundWebhookAuthTypes["DIRECIONAL_PERMUTAS"] = "direcional_permutas";
})(OutboundWebhookAuthTypes = exports.OutboundWebhookAuthTypes || (exports.OutboundWebhookAuthTypes = {}));
exports.WebhookBasicAuthSchema = zod_1.z.object({
    type: zod_1.z.enum([OutboundWebhookAuthTypes.BASIC, OutboundWebhookAuthTypes.USER_PASSWORD]),
    user: zod_1.z.string(),
    password: zod_1.z.string(),
});
exports.WebhookOauthAuthSchema = zod_1.z.object({
    type: zod_1.z.literal(OutboundWebhookAuthTypes.OAUTH),
    auth_url: zod_1.z.string(),
    method: zod_1.z.string(),
    client_id: zod_1.z.string(),
    client_secret: zod_1.z.string(),
    client_auth: zod_1.z.enum(['basic', 'body']),
    token_path: zod_1.z.object({
        location: zod_1.z.enum(['header', 'body']),
        path: zod_1.z.string(),
    }),
    grant_type: zod_1.z.enum(['client_credentials', 'refresh_token']).optional(),
    refresh_token: zod_1.z.string().optional(),
    redirect_uri: zod_1.z.string().optional(),
    scope: zod_1.z.string().optional(),
});
exports.WebhookDirecionalPermutasAuthSchema = zod_1.z.object({
    type: zod_1.z.literal(OutboundWebhookAuthTypes.DIRECIONAL_PERMUTAS),
    auth_url: zod_1.z.string(),
    method: zod_1.z.string(),
    token_path: zod_1.z.object({
        location: zod_1.z.literal('body'),
        path: zod_1.z.string().nullable(),
    }),
    integrationToken: zod_1.z.string(),
    secretName: zod_1.z.string(),
});
exports.WebhookNoneAuthSchema = zod_1.z.object({
    type: zod_1.z.literal(OutboundWebhookAuthTypes.NONE),
});
exports.OutboundWebhookAuthSchema = zod_1.z.union([
    exports.WebhookBasicAuthSchema,
    exports.WebhookOauthAuthSchema,
    exports.WebhookNoneAuthSchema,
    exports.WebhookDirecionalPermutasAuthSchema,
]);
